import { SizeThreshold, sizeThresholdMappings } from '../interfaces/mits-table';

export class MitsTableHelper {
  /**
   * Converts a SizeThreshold to an Pixel-Amount
   * @param sizeThreshold e.g. 'sm' or 'xl'
   * @returns e.g. 300
   */
  convertSizeThresholdToPixels(sizeThreshold: SizeThreshold): number {
    return sizeThresholdMappings[sizeThreshold];
  }

  /**
   * Returns if the provided pixel-width is greater then the threshold
   * @param pixels e.g. 300
   * @param threshold e.g. 'lg'
   */
  isPixelsInThreshold(pixels: number, threshold: SizeThreshold): boolean {
    return sizeThresholdMappings[threshold] > pixels;
  }

  /**
   * Gibt Kontrast zu Farbe zurück (Weiß / Schwarz).
   * @param color Farb-Code
   */
  getContrastColor(color: string) {
    const rgbColor = this.hexToRgb(color);
    if (
      rgbColor &&
      ((rgbColor.r < 160 && rgbColor.b < 160) || rgbColor.g < 160)
    ) {
      return '#ffffff';
    } else {
      return '#000000';
    }
  }

  /**
   * Konvertiert Hex zu RGB
   */
  hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }
}
